import {
  Box,
  BoxProps,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import React from "react";
import { Button } from "./Button";
import { getLoginURL, writeCookie } from "../../utils";
import { useAuth } from "../../auth";

const prepareAuthUrl = () => {
  writeCookie(
    "redirect_login",
    window.location.pathname + window.location.search,
    1,
  );
};

interface AuthenticatedActionProps extends BoxProps {
  callbackUrl?: string;
  backTo?: string;
}

export const AuthenticatedAction: React.FC<AuthenticatedActionProps> = ({
  onClick,
  children,
  callbackUrl,
  backTo,
  ...restProps
}) => {
  const { auth } = useAuth();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const profile = auth.getProfile();
    if (profile) {
      if (onClick) e.preventDefault();
      return onClick && onClick(e);
    }
    e.preventDefault();
    return onOpen();
  };

  const authUrl = getLoginURL(
    undefined,
    callbackUrl || process.env.RAZZLE_APP_BASE_URL,
    backTo,
  );

  return (
    <>
      <Box onClick={handleClick} {...restProps} data-testid="auth-opener">
        {children}
      </Box>

      <Modal isOpen={isOpen} onClose={onClose} isCentered preserveScrollBarGap>
        <ModalOverlay />
        <ModalContent
          boxShadow="0 8px 24px 0 rgba(0,6,17,0.1)"
          borderRadius="0 0 16px 16px"
        >
          <ModalHeader>Feature available to logged in users</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>
              To use this feature you must be logged in. Login or sign up to get
              started.
            </Text>
          </ModalBody>

          <ModalFooter>
            <Button
              href={authUrl}
              onClick={prepareAuthUrl}
              label="LOG IN"
              mr="20px"
            />
            <Button
              href={authUrl}
              onClick={prepareAuthUrl}
              outline
              label="SIGN UP"
            />
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
